import React, {useEffect, useMemo, useRef} from 'react';
import {getCssSizeValue, getHtmlFromRedactorField} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import GridContainer from "@/components/common/GridContainer";
import Text from "@/components/common/Text";
import styled from "styled-components";
import Section, {Container} from "@/components/Menu/Desktop/Section";
import useGlobals from "@/hooks/useGlobals";
import BranchSelect from "@/components/BranchSelect";
import BothMaps from "@/components/Maps/BothMaps";
import {useSelector} from "react-redux";

const StyledBranchSelect = styled(BranchSelect)`
	.options{
		max-height: ${getCssSizeValue(100, BREAKPOINTS.TABLET)}
	}
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        .options{
            max-height: unset;
        }
    }
`

const Wrapper = styled(GridContainer)`
	position: relative;
	z-index: 1;
	height: calc(100lvh -  var(--paddingY));
	overflow-x: hidden;
	overflow-y: auto;
	grid-gap: unset;
`

const MapContainer = styled(GridContainer)`
	//display: none;
    display: flex;
	justify-content: space-between;
	position: relative;
	overflow: hidden;
	background-color: ${({theme}) => theme.colors.richBlack};
	gap: 0;
    margin: 0 calc(var(--paddingX) * -1) !important;
	padding:
            ${getCssSizeValue(75, BREAKPOINTS.DESKTOP)}
            ${getCssSizeValue(50, BREAKPOINTS.DESKTOP)}
            ${getCssSizeValue(50, BREAKPOINTS.DESKTOP)}
            ${getCssSizeValue(60, BREAKPOINTS.DESKTOP)}
	;
	
	.both-maps-wrapper{
		width: ${getCssSizeValue(300, BREAKPOINTS.TABLET)};
	}
	.current-info{
		font-weight: ${({ theme }) => theme.fontWeight.medium};
		margin-top: ${getCssSizeValue(40, BREAKPOINTS.TABLET)};
    }
    .current-desc{
        width: ${getCssSizeValue(342, BREAKPOINTS.TABLET)};
        margin-top: ${getCssSizeValue(40, BREAKPOINTS.TABLET)};
    }

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        flex-direction: column;
        margin-left: calc(var(--grid-gap) * -1) !important;
        margin-right: calc(var(--paddingX) * -1) !important;
        .current-info{
            width: unset;
            margin-top: unset;
        }
        .current-desc{
            margin-top: unset;
            width: unset;
        }
		
        .both-maps-wrapper{
            width: unset;
        }
    }
`

const Div = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: ${getCssSizeValue(24,BREAKPOINTS.TABLET)};
	width: ${getCssSizeValue(226,BREAKPOINTS.TABLET)};
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        row-gap: ${getCssSizeValue(16,BREAKPOINTS.DESKTOP)};
		width: auto;
    }
	
`


const DesktopMenu = ({ items=[],  ...props }) => {
	const globals = useGlobals()
	// const isTablet = useIsTablet()
	const WrapperRef = useRef()
	const isMenuOpen = useSelector((state) => state.menu.open);
	const MapData = useMemo(() => ({
		info: getHtmlFromRedactorField(globals?.mapInfo || ''),
		currentState: globals?.mapCurrentStateText || ''
	}),[globals])
	const [up, down] = useMemo(() => {
		const wwds = items.slice(0,3)
		const info = items.find((item) => item.isInfoCategory)
		const up = [wwds, info]

		const help = items.slice(4,6)
		const shortcuts = items.find((item) => item.isShortcutsCategory)
		const down = [items[3], help, items[6], shortcuts]
		return [up, down]
	},[items])

	useEffect(() => {
		if(isMenuOpen){
			//reset inner scroll position on menu open, mainly for tablet
			WrapperRef.current.scroll({
				top: 0
			})
		}
	}, [isMenuOpen]);

	return (
		<Wrapper ref={WrapperRef} className={`no-margin padding`}  {...props}>
			<Container className="no-margin col-tablet-8 col-desktop-12 negative-margin-x">
				<Section data={up} />
				<Section data={down} down />
			</Container>
			<MapContainer className="no-margin col-tablet-8 col-desktop-4">
				<Text as="div" className="current-desc typo-borna typo-borna-19 " color="white" dangerouslySetInnerHTML={MapData.info} />
				<Div>
					<Text className="current-info typo-strawford typo-strawford-19i " color="white">
						{MapData.currentState}
					</Text>
					<StyledBranchSelect/>
				</Div>
				<BothMaps/>
			</MapContainer>
		</Wrapper>
	)
}

export default DesktopMenu;
